<template>
  <GraphStatistics>
    <template slot="title">
      {{ $t("management.staticticsByAccountCreate") }}
    </template>
    <template slot="excel">
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </template>
    <template slot="filter">
      <tr>
        <th>{{ $t("common.year") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.year"
            @change="setStatistics"
          >
            <option v-for="(year, index) in setUp.yearList" :key="index">
              {{ year }}
            </option>
          </select>
        </td>
        <th>{{ $t("management.userType") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.role"
            @change="setStatistics"
          >
            <option value="total">ALL</option>
            <option value="1">Employee</option>
            <option value="2">Dealer</option>
            <option value="3">User</option>
          </select>
        </td>
      </tr>
    </template>
    <template slot="graph">
      <ChartTemplate id="chartTemplate" ref="chartTemplate" />
    </template>
  </GraphStatistics>
</template>

<script>
import GraphStatistics from "@/components/management/statistics/common/GraphStatistics";
import ChartTemplate from "@/components/management/statistics/accountcreate/ChartTemplate";
import { accountCreateStatisticsExcel } from "@/api/statistics";
export default {
  components: {
    ChartTemplate,
    GraphStatistics,
  },
  data() {
    return {
      setUp: {
        yearList: [],
      },
      form: {
        year: "",
        role: "",
      },
    };
  },
  async created() {
    this.setYearSelect();
    await this.setDefaultFilter();
    this.setStatistics();
  },
  methods: {
    setYearSelect() {
      var firstYear = 2021;
      var now = new Date();
      var lastYear = now.getFullYear();
      this.form.year = lastYear;

      var yearList = [];
      for (lastYear; lastYear >= firstYear; lastYear--) {
        yearList.push(lastYear);
      }
      this.setUp.yearList = yearList;
    },
    setDefaultFilter() {
      this.form.role = "total";
    },
    async setStatistics() {
      await this.$refs.chartTemplate.getData(this.form.year, this.form.role);
    },
    async downExcel() {
      let loader = this.$loading.show({});
      let result = await accountCreateStatisticsExcel(this.form.year, this.form.role);
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "StaticticsBy_AccountCreated.xls";
      link.click();
      window.URL.revokeObjectURL(url);
      loader.hide();
    },
  },
};
</script>

<style></style>
